import React from 'react';
import { Col } from '@visalex/core';

import ListItem from '../../Visas/Common/ListItem/ListItem';

import styles from './OptionColumns.module.scss';

export type OptionColumnType = {
  imageUrl: string;
  imageAlt: string;
  title: string;
  description: string;
};

type OptionColumnsProps = {
  options: OptionColumnType[];
  withDottedLines: boolean;
};
const OptionColumns = ({ options, withDottedLines }: OptionColumnsProps) => {
  return (
    <>
      {options.map((step, key) => (
        <Col xs={12} md={6} lg={4} key={key} className={styles['option-column']}>
          <ListItem
            withDottedLines={withDottedLines}
            step={step}
            positionNumber={key}
            isLast={key === options.length - 1}
          />
        </Col>
      ))}
    </>
  );
};

export default OptionColumns;
